export default class Reason {
    constructor(reasonId, messageKey, localizedMessageKey, hintKey) {
        this.id = reasonId;
        this._messageKey = messageKey;
        this._uiMessageKey = localizedMessageKey;
        this._hintKey = hintKey;
    }

    getUIMessage () {
        return this._uiMessageKey || this._messageKey;
    };
}